import React, { useEffect } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import SmashStripe from '../../../components/SmashStripe/SmashStripe';
import { paymentMethodState, createStripeSetupIntent, resetPaymentMethod, updatePaymentStatus, setUserAction } from '../paymentMethodSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useStripe } from '@stripe/react-stripe-js';


const PaymentMethodForm = () => {
    const dispatch = useAppDispatch();
    const { payment } = useAppSelector(paymentMethodState);
    const stripe = useStripe();

    useEffect(() => {
        dispatch(setUserAction('updatePaymentMethod'))
      }, []);

    useEffect(() => {
        if (payment.token && payment.paymentStatus === 'stripeTokenOK' && payment.userAction === 'updatePaymentMethod') {
            dispatch(createStripeSetupIntent({token: payment.token}));
        }
    }, [payment]);


    const savePaymentMethod = async () => {
        if(stripe && payment.secret && payment.token) {
            dispatch(updatePaymentStatus({status:'updatingPaymentMethod'}));            

            await stripe.confirmCardSetup(payment.secret, { payment_method: { card: { token: payment.token } }});
            // show a toast
            dispatch(updatePaymentStatus({status:'updatedPaymentMethod'})); 
            dispatch(resetPaymentMethod())
        }    
    }

  return (
    <>

        {payment.paymentStatus === 'updatingPaymentMethod' && <SmashSpinner/>}
        {payment.paymentStatus !== 'updatingPaymentMethod' && <SmashStripe/>}

        <Row>
            <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                <Button disabled={payment.paymentStatus!=='confirmSetupIntent'} onClick={savePaymentMethod}>
                {['generatingStripeToken', 'stripeTokenOK'].indexOf(payment.paymentStatus) > -1 && <SmashSpinner variant="light" size="sm" />}
                {['generatingStripeToken', 'stripeTokenOK'].indexOf(payment.paymentStatus) === -1 && <>Save</>}
                </Button>
            </Col>
        </Row>
        
    </>

  )
}

export default PaymentMethodForm